import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewQrCodeComponent } from './view-qr-code/view-qr-code.component';
import {Trip2ThemeModule} from '../../../../trip2-theme/trip2-theme.module';

@NgModule({
  imports: [
    CommonModule,
    Trip2ThemeModule,
  ],
  exports: [
    ViewQrCodeComponent
  ],
  declarations: [
    ViewQrCodeComponent
  ]
})
export class RiderQrCodeModule { }



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-qr-code/rider-qr-code.module.ts